import showToast from '../components/ToastComponent';
import { useState } from 'react';
import { updateEmailNotificationStatus } from '../service/updateEmailNotificationStatus';

const updateNotificationStatus = (): [
  boolean,
  (accessToken: string | undefined, taskExecutionId: string) => Promise<void>,
] => {
  const [loading, setLoading] = useState<boolean>(false);

  const updateBulkNotificationStatus = async (
    accessToken: string | undefined,
    taskExecutionId: string,
  ) => {
    if (!accessToken) return;

    const response = await updateEmailNotificationStatus(
      accessToken!,
      taskExecutionId,
    );
    if (typeof response === 'number') {
      showToast({
        type: 'warning',
        message: 'Failed to update notification status.',
      });
      setLoading(false);
      return;
    }
    setLoading(false);
  };

  return [loading, updateBulkNotificationStatus];
};

export default updateNotificationStatus;
